import { render, staticRenderFns } from "./gif.vue?vue&type=template&id=44b90c7e&scoped=true&"
import script from "./gif.vue?vue&type=script&lang=js&"
export * from "./gif.vue?vue&type=script&lang=js&"
import style0 from "./gif.vue?vue&type=style&index=0&id=44b90c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b90c7e",
  null
  
)

export default component.exports